import { IconButton } from '../IconButton';
export var Profile = IconButton; // This exists only to extract props.

export default (function (props) {});